// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__10_CL","content":"styles_content__2lyKD","checkbox":"styles_checkbox__3NB5r","checkboxLabel":"styles_checkboxLabel__10O_X"};